import { render, staticRenderFns } from "./VaultSettings.vue?vue&type=template&id=5987dc6f"
import script from "./VaultSettings.vue?vue&type=script&lang=js"
export * from "./VaultSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports